// Mock API layer - Replace with real API calls in future
// Usage: Simply replace fetch calls with real API endpoints

const MOCK_USERS = [
  {
    id: 12345678,
    firstName: 'Иван',
    username: 'ivan_petrov',
    hours: 15.5,
    consumedHours: 21.75,
    joinDate: '2024-06-15 14:32:00',
    utm: {
      source: 'google',
      medium: 'cpc',
      campaign: 'summer_sale',
      content: 'banner_1'
    },
    payments: [
      { id: 1, date: '2025-01-20 09:15:00', amount: 9.99 },
      { id: 2, date: '2025-01-13 16:45:00', amount: 9.99 },
      { id: 3, date: '2024-12-20 11:20:00', amount: 19.99 }
    ],
    summaries: [
      { id: 's1', title: 'Отчет по квартальным результатам', url: 'https://audio-storage.example.com/s1.mp3', date: '2025-01-23 10:30:00', likes: 12, dislikes: 2, userReaction: 'like', views: 234, generationId: 9001, generationStatus: 'succeed', generationCostRub: 17.3, generationCostUsd: 0.18 },
      { id: 's2', title: 'Краткое резюме встречи', url: 'https://audio-storage.example.com/s2.mp3', date: '2025-01-20 15:45:00', likes: 8, dislikes: 0, userReaction: 'none', views: 156, generationId: null, generationStatus: null, generationCostRub: null, generationCostUsd: null }
    ],
    finance: {
      transactions: { total: 3, successful: 2 },
      revenueRub: { succeeded: 1950, waitingForCapture: 0, canceled: 0 },
      generationCosts: { totalRub: 721, totalUsd: 7.42, successful: 10, failed: 1, total: 11 },
      summaries: { total: 2, averageGenerationCostRub: 17.3 },
      balance: { totalMsLeft: 55800000, totalMsConsumed: 78300000, totalHoursLeft: 15.5, totalHoursConsumed: 21.75 },
      totalMsSpend: 78300000
    }
  },
  {
    id: 87654321,
    firstName: 'Мария',
    username: 'maria_smirnova',
    hours: 2,
    consumedHours: 8.5,
    joinDate: '2024-09-20 08:10:00',
    payments: [
      { id: 4, date: '2025-01-15 13:20:00', amount: 9.99 }
    ],
    summaries: [
      { id: 's3', title: 'Протокол совещания', url: 'https://audio-storage.example.com/s3.mp3', date: '2025-01-22 14:15:00', likes: 5, dislikes: 1, userReaction: 'dislike', views: 89 }
    ]
  },
  {
    id: 11223344,
    firstName: 'Петр',
    username: 'petr_volkov',
    hours: 0.5,
    consumedHours: 4.2,
    joinDate: '2024-11-10 17:25:00',
    payments: [
      { id: 5, date: '2025-01-18 12:40:00', amount: 4.99 },
      { id: 6, date: '2025-01-01 10:05:00', amount: 9.99 }
    ],
    summaries: [
      { id: 's4', title: 'Конспект лекции', url: 'https://audio-storage.example.com/s4.mp3', date: '2025-01-18 11:50:00', likes: 15, dislikes: 3, userReaction: 'like', views: 312 }
    ]
  },
  {
    id: 55667788,
    firstName: 'Анна',
    username: 'anna_kuznetsova',
    hours: 24,
    consumedHours: 37.8,
    joinDate: '2024-05-01 09:00:00',
    payments: [
      { id: 7, date: '2025-01-10 14:30:00', amount: 29.99 },
      { id: 8, date: '2024-12-10 16:15:00', amount: 29.99 }
    ],
    summaries: [
      { id: 's5', title: 'Итоги рабочего дня', url: 'https://audio-storage.example.com/s5.mp3', date: '2025-01-21 17:20:00', likes: 22, dislikes: 1, userReaction: 'like', views: 445 },
      { id: 's6', title: 'Заметки из подкаста', url: 'https://audio-storage.example.com/s6.mp3', date: '2025-01-19 13:10:00', likes: 10, dislikes: 0, userReaction: 'none', views: 201 }
    ]
  },
  {
    id: 99887766,
    firstName: 'Дмитрий',
    username: 'dmitry_sokolov',
    hours: 8,
    consumedHours: 13.25,
    joinDate: '2024-08-05 12:15:00',
    payments: [
      { id: 9, date: '2025-01-05 11:35:00', amount: 14.99 }
    ],
    summaries: [
      { id: 's7', title: 'Запись интервью', url: 'https://audio-storage.example.com/s7.mp3', date: '2025-01-24 09:45:00', likes: 7, dislikes: 2, userReaction: 'none', views: 178 }
    ]
  }
];

const MOCK_STATS = {
  totalIncome: 12450.50,
  monthlyIncome: 2840.50,
  weeklyIncome: 680.25,
  dailyIncome: 145.80,
  totalUsers: 1234,
  activeUsers: 856,
  mau: 456,
  dau: 89,
  onlineUsers: 23,
  totalSessions: 56789,
  totalNotes: 5678,
  notesToday: 42,
  notesYesterday: 38,
  incomeChartData: [150, 180, 120, 200, 160, 220, 145],
  subscriptionDistribution: {
    basic: 350,
    standard: 600,
    premium: 284
  },
  totalSummaries: 5678,
  summariesToday: 42,
  totalLikes: 3456,
  totalDislikes: 234,
  totalViews: 45230,
  viewsToday: 1250,
  summariesChartData: [120, 145, 160, 180, 190, 200, 210],
  summaryModels: [
    { model: 'gpt-4o-mini', likes: 1820, dislikes: 95 },
    { model: 'gpt-3.5-turbo', likes: 1035, dislikes: 118 },
    { model: 'custom-legacy', likes: 601, dislikes: 21 }
  ],
  usersChartData: [50, 65, 55, 80, 95, 110, 125],
  recentSummaries: [
    { id: 's7', title: 'Запись интервью', model: 'gpt-4o-mini', userId: 99887766, userName: 'Дмитрий', date: '2025-01-24 09:45:00', likes: 7, dislikes: 2, userReaction: 'none', views: 178, generationId: 9010, generationStatus: 'failed', generationCostRub: null, generationCostUsd: null },
    { id: 's1', title: 'Отчет по квартальным результатам', model: 'gpt-4o-mini', userId: 12345678, userName: 'Иван', date: '2025-01-23 10:30:00', likes: 12, dislikes: 2, userReaction: 'like', views: 234, generationId: 9001, generationStatus: 'succeed', generationCostRub: 17.3, generationCostUsd: 0.18 },
    { id: 's5', title: 'Итоги рабочего дня', model: 'gpt-3.5-turbo', userId: 55667788, userName: 'Анна', date: '2025-01-21 17:20:00', likes: 22, dislikes: 1, userReaction: 'like', views: 445, generationId: 9005, generationStatus: 'succeed', generationCostRub: 25.7, generationCostUsd: 0.27 },
    { id: 's3', title: 'Протокол совещания', model: 'gpt-3.5-turbo', userId: 87654321, userName: 'Мария', date: '2025-01-22 14:15:00', likes: 5, dislikes: 1, userReaction: 'dislike', views: 89, generationId: 9003, generationStatus: 'succeed', generationCostRub: 14.8, generationCostUsd: 0.15 },
    { id: 's2', title: 'Краткое резюме встречи', model: 'custom-legacy', userId: 12345678, userName: 'Иван', date: '2025-01-20 15:45:00', likes: 8, dislikes: 0, userReaction: 'like', views: 156, generationId: null, generationStatus: null, generationCostRub: null, generationCostUsd: null }
  ],
  financeOverview: {
    transactions: { total: 124, succeeded: 109, waitingForCapture: 7, canceled: 8 },
    revenue: { rub: 284350, averageCheckRub: 2609 },
    generationExpenses: { rub: 31745, usd: 325.8, averageRub: 291, total: 133, successful: 109, failed: 24 },
    grossProfitRub: 252605
  },
  tariffPurchases: [
    { id: 1, purchaseUUID: 'pur_001', tariffId: 101, tariffName: '30 часов', status: 'succeeded', pricePaidRub: 1490, msAmount: 108000000, confirmationUrl: null, createdAt: '2026-04-27T10:00:00.000Z', updatedAt: '2026-04-27T10:05:00.000Z', user: { id: 12345678, firstName: 'Иван', username: 'ivan_petrov' } },
    { id: 2, purchaseUUID: 'pur_002', tariffId: 102, tariffName: '100 часов', status: 'waiting_for_capture', pricePaidRub: 3990, msAmount: 360000000, confirmationUrl: 'https://pay.example.com/confirm/2', createdAt: '2026-04-27T12:00:00.000Z', updatedAt: '2026-04-27T12:03:00.000Z', user: { id: 87654321, firstName: 'Мария', username: 'maria_smirnova' } },
    { id: 3, purchaseUUID: 'pur_003', tariffId: 101, tariffName: '30 часов', status: 'canceled', pricePaidRub: 1490, msAmount: 108000000, confirmationUrl: null, createdAt: '2026-04-26T11:00:00.000Z', updatedAt: '2026-04-26T11:02:00.000Z', user: { id: 11223344, firstName: 'Петр', username: 'petr_volkov' } },
    { id: 4, purchaseUUID: 'pur_004', tariffId: 103, tariffName: '300 часов', status: 'succeeded', pricePaidRub: 9990, msAmount: 1080000000, confirmationUrl: null, createdAt: '2026-04-25T18:00:00.000Z', updatedAt: '2026-04-25T18:01:00.000Z', user: { id: 55667788, firstName: 'Анна', username: 'anna_kuznetsova' } }
  ],
  topTariffs: [
    { tariffId: 103, tariffName: '300 часов', purchasesCount: 12, revenueRub: 119880, soldMs: 12960000000 },
    { tariffId: 102, tariffName: '100 часов', purchasesCount: 29, revenueRub: 115710, soldMs: 10440000000 },
    { tariffId: 101, tariffName: '30 часов', purchasesCount: 51, revenueRub: 75990, soldMs: 5508000000 }
  ],
  productMetrics: {
    activationRate: { ratePercent: 70.0, activatedUsers: 840, totalUsers: 1200 },
    timeToValue: { median: { minutes: 15.0 }, distribution: { within5Min: 120 } },
    retentionRate: {
      day7: { ratePercent: 5.0, eligibleUsers: 900, retainedUsers: 45 },
      day30: { ratePercent: 6.0, health: 'warning' }
    },
    stickinessRatio: {
      summaries: { ratioPercent: 23.3, dau: 42, mau: 180 }
    }
  },
  referralsOverview: {
    total: {
      referralCodes: 150,
      activeCodes: 145,
      totalReferrals: 320,
      pendingReferrals: 45,
      grantedReferrals: 270,
      canceledReferrals: 5
    },
    rewards: {
      totalHoursGranted: 2700,
      totalMsGranted: 9720000000,
      averageHoursPerReferral: 10
    },
    growth: {
      referralsLast7Days: 25,
      referralsLast30Days: 85,
      referralsThisMonth: 40
    },
    topReferrers: [
      { userId: 12345678, firstName: 'Иван', lastName: 'Петров', username: 'ivan_petrov', totalReferrals: 15, successfulReferrals: 12, hoursEarned: 120 },
      { userId: 55667788, firstName: 'Анна', lastName: 'Кузнецова', username: 'anna_kuznetsova', totalReferrals: 12, successfulReferrals: 10, hoursEarned: 100 },
      { userId: 87654321, firstName: 'Мария', lastName: 'Смирнова', username: 'maria_smirnova', totalReferrals: 8, successfulReferrals: 7, hoursEarned: 70 }
    ]
  },
  referralsList: [
    { id: 1, referrer: { id: 12345678, firstName: 'Иван', lastName: 'Петров', username: 'ivan_petrov', email: 'ivan@example.com' }, referee: { id: 99887766, firstName: 'Дмитрий', lastName: 'Соколов', username: 'dmitry_sokolov', email: 'dmitry@example.com', registeredAt: '2026-07-20T10:30:00Z' }, code: 'IVAN1234', status: 'granted', rewardHours: 10, createdAt: '2026-07-20T10:30:00Z', grantedAt: '2026-07-20T10:35:00Z' },
    { id: 2, referrer: { id: 55667788, firstName: 'Анна', lastName: 'Кузнецова', username: 'anna_kuznetsova', email: 'anna@example.com' }, referee: { id: 11223344, firstName: 'Петр', lastName: 'Волков', username: 'petr_volkov', email: 'petr@example.com', registeredAt: '2026-07-22T14:15:00Z' }, code: 'ANNA5678', status: 'pending', rewardHours: 10, createdAt: '2026-07-22T14:15:00Z', grantedAt: null },
    { id: 3, referrer: { id: 87654321, firstName: 'Мария', lastName: 'Смирнова', username: 'maria_smirnova', email: 'maria@example.com' }, referee: { id: 55443322, firstName: 'Елена', lastName: 'Новикова', username: 'elena_novikova', email: 'elena@example.com', registeredAt: '2026-07-25T09:00:00Z' }, code: 'MARIA901', status: 'granted', rewardHours: 10, createdAt: '2026-07-25T09:00:00Z', grantedAt: '2026-07-25T09:05:00Z' }
  ],
  referralCodes: [
    { id: 1, code: 'IVAN1234', user: { id: 12345678, firstName: 'Иван', lastName: 'Петров', username: 'ivan_petrov' }, active: true, totalReferrals: 15, successfulReferrals: 12, createdAt: '2026-01-15T08:00:00Z' },
    { id: 2, code: 'ANNA5678', user: { id: 55667788, firstName: 'Анна', lastName: 'Кузнецова', username: 'anna_kuznetsova' }, active: true, totalReferrals: 12, successfulReferrals: 10, createdAt: '2026-02-10T10:30:00Z' },
    { id: 3, code: 'MARIA901', user: { id: 87654321, firstName: 'Мария', lastName: 'Смирнова', username: 'maria_smirnova' }, active: true, totalReferrals: 8, successfulReferrals: 7, createdAt: '2026-03-05T12:45:00Z' }
  ]
};

// Simulate API delay
const DELAY = 300;

const delay = (ms = DELAY) => new Promise(resolve => setTimeout(resolve, ms));

const getNotificationStorage = () => {
  const storage = window;

  if (!storage.__MOCK_NOTIFICATIONS__) {
    storage.__MOCK_NOTIFICATIONS__ = [
      {
        id: 1700000000001,
        title: 'Весеннее обновление',
        status: 'completed',
        totalRecipients: 120,
        sentCount: 118,
        failedCount: 2,
        createdAt: '2026-04-02T10:00:00.000Z',
        updatedAt: '2026-04-02T10:25:00.000Z',
        startedAt: '2026-04-02T10:01:00.000Z',
        finishedAt: '2026-04-02T10:25:00.000Z'
      },
      {
        id: 1700000000002,
        title: 'Промокод для новых пользователей',
        status: 'in_progress',
        totalRecipients: 85,
        sentCount: 52,
        failedCount: 1,
        createdAt: '2026-04-05T12:00:00.000Z',
        updatedAt: '2026-04-05T12:12:00.000Z',
        startedAt: '2026-04-05T12:01:00.000Z',
        finishedAt: null
      }
    ];
  }

  return storage.__MOCK_NOTIFICATIONS__;
};

const MOCK_AUTH_USER = {
  id: 'admin_1',
  username: 'admin',
  password: 'password123', // In real app, this would be hashed
  firstName: 'Admin',
  lastName: 'User'
};

export const API = {
  // Auth
  auth: {
    login: async (username, password) => {
      await delay(500);
      if (username === MOCK_AUTH_USER.username && password === MOCK_AUTH_USER.password) {
        
        // Generate mock tokens
        const accessToken = 'mock_access_token_' + Date.now();
        const refreshToken = 'mock_refresh_token_' + Date.now();
        return { 
          success: true, 
          data: { 
            accessToken, 
            refreshToken,
            user: {
              id: MOCK_AUTH_USER.id,
              username: MOCK_AUTH_USER.username,
              firstName: MOCK_AUTH_USER.firstName
            }
          } 
        };
      }
      return { success: false, error: 'Неверное имя пользователя или пароль' };
    },

    refreshToken: async (refreshToken) => {
      await delay(300);
      if (refreshToken && refreshToken.startsWith('mock_refresh_token_')) {
        return {
          success: true,
          data: {
            accessToken: 'mock_access_token_' + Date.now()
          }
        };
      }
      return { success: false, error: 'Invalid refresh token' };
    },

    logout: async () => {
      await delay(200);
      return { success: true };
    }
  },

  // Users
  users: {
    getAll: async () => {
      await delay();
      return { success: true, data: MOCK_USERS };
    },
    
    getById: async (id) => {
      await delay();
      const user = MOCK_USERS.find(u => u.id === id);
      if (!user) return { success: false, error: 'User not found' };
      return { success: true, data: user };
    },

    getFinance: async (id) => {
      await delay();
      const user = MOCK_USERS.find(u => u.id === id);
      if (!user) return { success: false, error: 'User not found' };
      return { success: true, data: user.finance };
    },

    addHours: async (userId, hours, reason) => {
      await delay();
      const user = MOCK_USERS.find(u => u.id === userId);
      if (!user) return { success: false, error: 'User not found' };
      user.hours += parseFloat(hours);
      return { 
        success: true, 
        data: { 
          userId, 
          addedHours: hours, 
          newTotal: user.hours,
          reason 
        } 
      };
    },

    search: async (query, limit = 5) => {
      await delay();
      const filtered = MOCK_USERS.filter(user =>
        user.firstName.toLowerCase().includes(query.toLowerCase()) ||
        user.username.toLowerCase().includes(query.toLowerCase()) ||
        user.id.toString().includes(query)
      );
      return { success: true, data: filtered.slice(0, limit) };
    }
  },

  finance: {
    getOverview: async () => {
      await delay();
      return { success: true, data: MOCK_STATS.financeOverview };
    },

    getTariffPurchases: async ({ page = 1, limit = 20, topLimit = 5 } = {}) => {
      await delay();
      const startIndex = (page - 1) * limit;
      return {
        success: true,
        data: {
          data: MOCK_STATS.tariffPurchases.slice(startIndex, startIndex + limit),
          topTariffs: MOCK_STATS.topTariffs.slice(0, topLimit).map((item, index) => ({
            ...item,
            rank: index + 1
          })),
          liabilities: {
            paidHoursLeft: 1
          },
          pagination: {
            page,
            limit,
            total: MOCK_STATS.tariffPurchases.length
          }
        }
      };
    }
  },

  notifications: {
    testSend: async () => {
      await delay();
      return { success: true, data: { success: true } };
    },

    start: async (payload = {}) => {
      await delay();
      const id = Date.now();
      const notifications = getNotificationStorage();
      const now = new Date().toISOString();
      notifications.unshift({
        id,
        title: payload.title || 'Без названия',
        status: 'pending',
        totalRecipients: 5,
        sentCount: 0,
        failedCount: 0,
        processedCount: 0,
        remainingCount: 5,
        createdAt: now,
        updatedAt: now,
        startedAt: now,
        finishedAt: null,
        lastError: null
      });
      return {
        success: true,
        data: {
          id,
          status: 'pending',
          totalRecipients: 5,
          sentCount: 0,
          failedCount: 0
        }
      };
    },

    status: async (notificationId) => {
      await delay();
      const notifications = getNotificationStorage();
      const campaign = notifications.find(c => c.id === Number(notificationId));
      if (!campaign) {
        return { success: false, error: 'Notification not found' };
      }
      if (campaign.status === 'pending') {
        campaign.status = 'in_progress';
        campaign.updatedAt = new Date().toISOString();
      }
      if (campaign.status === 'in_progress') {
        campaign.sentCount = Math.min(campaign.totalRecipients, campaign.sentCount + 2);
        campaign.processedCount = campaign.sentCount + campaign.failedCount;
        campaign.remainingCount = Math.max(campaign.totalRecipients - campaign.processedCount, 0);
        campaign.updatedAt = new Date().toISOString();
        if (campaign.sentCount >= campaign.totalRecipients) {
          campaign.status = 'completed';
          campaign.finishedAt = new Date().toISOString();
          campaign.updatedAt = campaign.finishedAt;
          campaign.processedCount = campaign.totalRecipients;
          campaign.remainingCount = 0;
        }
      }
      if (campaign.processedCount === undefined) {
        campaign.processedCount = (campaign.sentCount || 0) + (campaign.failedCount || 0);
      }
      if (campaign.remainingCount === undefined) {
        campaign.remainingCount = Math.max((campaign.totalRecipients || 0) - campaign.processedCount, 0);
      }
      if (campaign.lastError === undefined) {
        campaign.lastError = null;
      }
      return { success: true, data: { data: campaign } };
    },

    list: async (params = {}) => {
      await delay();
      const page = Number(params.page ?? 1);
      const limit = Number(params.limit ?? 10);
      const notifications = getNotificationStorage();
      const start = (page - 1) * limit;

      return {
        success: true,
        data: {
          data: notifications.slice(start, start + limit),
          pagination: {
            page,
            limit,
            total: notifications.length
          }
        }
      };
    },

    getById: async (notificationId) => {
      await delay();
      const notifications = getNotificationStorage();
      const campaign = notifications.find(c => c.id === Number(notificationId));

      if (!campaign) {
        return { success: false, error: 'Notification not found' };
      }

      return { success: true, data: campaign };
    }
  },

  // Payments
  payments: {
    getByUserId: async (userId) => {
      await delay();
      const user = MOCK_USERS.find(u => u.id === userId);
      if (!user) return { success: false, error: 'User not found' };
      return { success: true, data: user.payments };
    },

    getAll: async () => {
      await delay();
      const allPayments = MOCK_USERS.flatMap(user =>
        user.payments.map(p => ({ ...p, userId: user.id, userName: user.firstName }))
      );
      return { success: true, data: allPayments };
    }
  },

  // Statistics
  stats: {
    getStats: async () => {
      await delay();
      return {
        success: true,
        data: {
          users: {
            total: MOCK_STATS.totalUsers,
            ma: MOCK_STATS.mau,
            da: MOCK_STATS.dau,
            online: MOCK_STATS.onlineUsers
          },
          sessions: {
            total: MOCK_STATS.totalSessions
          },
          summaries: {
            total: MOCK_STATS.totalSummaries,
            today: MOCK_STATS.summariesToday,
            likes: MOCK_STATS.totalLikes,
            dislikes: MOCK_STATS.totalDislikes,
            views: {
              total: MOCK_STATS.totalViews,
              today: MOCK_STATS.viewsToday
            }
          }
        }
      };
    },

    getOverview: async () => {
      await delay();
      return { 
        success: true, 
        data: {
          totalIncome: MOCK_STATS.totalIncome,
          monthlyIncome: MOCK_STATS.monthlyIncome,
          weeklyIncome: MOCK_STATS.weeklyIncome,
          dailyIncome: MOCK_STATS.dailyIncome,
          users: {
            total: MOCK_STATS.totalUsers,
            active: MOCK_STATS.activeUsers
          },
          summaries: {
            total: MOCK_STATS.totalSummaries,
            likes: MOCK_STATS.totalLikes,
            dislikes: MOCK_STATS.totalDislikes,
            today: MOCK_STATS.summariesToday,
            views: {
              total: MOCK_STATS.totalViews,
              today: MOCK_STATS.viewsToday
            },
            models: MOCK_STATS.summaryModels
          },
          totalNotes: MOCK_STATS.totalNotes,
          notesToday: MOCK_STATS.notesToday,
          notesYesterday: MOCK_STATS.notesYesterday
        } 
      };
    },

    getIncomeChart: async (period = 'week') => {
      await delay();
      return { 
        success: true, 
        data: {
          labels: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
          values: MOCK_STATS.incomeChartData
        }
      };
    },

    getSubscriptionDistribution: async () => {
      await delay();
      return {
        success: true,
        data: {
          labels: ['Базовая (30ч/мес)', 'Стандарт (100ч/мес)', 'Премиум (300ч/мес)'],
          values: [
            MOCK_STATS.subscriptionDistribution.basic,
            MOCK_STATS.subscriptionDistribution.standard,
            MOCK_STATS.subscriptionDistribution.premium
          ]
        }
      };
    },

    getSummariesOverview: async () => {
      await delay();
      return {
        success: true,
        data: {
          summaries: {
            total: MOCK_STATS.totalSummaries,
            likes: MOCK_STATS.totalLikes,
            dislikes: MOCK_STATS.totalDislikes,
            today: MOCK_STATS.summariesToday,
            views: {
              total: MOCK_STATS.totalViews,
              today: MOCK_STATS.viewsToday
            },
            models: MOCK_STATS.summaryModels
          }
        }
      };
    },

    getSummariesChart: async () => {
      await delay();
      return {
        success: true,
        data: {
          labels: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
          values: MOCK_STATS.summariesChartData
        }
      };
    },

    getUsersChart: async () => {
      await delay();
      return {
        success: true,
        data: {
          labels: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
          values: MOCK_STATS.usersChartData
        }
      };
    },

    getRecentSummaries: async (page = 1, limit = 10) => {
      await delay();
      const startIndex = (page - 1) * limit;
      const sliced = MOCK_STATS.recentSummaries.slice(startIndex, startIndex + limit);
      return {
        success: true,
        data: {
          data: sliced,
          pagination: {
            total: MOCK_STATS.recentSummaries.length,
            page,
            limit
          }
        }
      };
    },

    getModelsReactions: async () => {
      await delay();
      return {
        success: true,
        data: MOCK_STATS.summaryModels
      };
    },

    getProductMetrics: async () => {
      await delay();
      return {
        success: true,
        data: MOCK_STATS.productMetrics
      };
    }
  },

  referrals: {
    getOverview: async () => {
      await delay();
      return {
        success: true,
        data: MOCK_STATS.referralsOverview
      };
    },

    getAll: async (params = {}) => {
      await delay();
      const page = Number(params.page ?? 1);
      const limit = Number(params.limit ?? 20);
      const startIndex = (page - 1) * limit;
      const sliced = MOCK_STATS.referralsList.slice(startIndex, startIndex + limit);
      return {
        success: true,
        data: {
          data: sliced,
          pagination: {
            page,
            limit,
            total: MOCK_STATS.referralsList.length,
            totalPages: Math.ceil(MOCK_STATS.referralsList.length / limit)
          }
        }
      };
    },

    getById: async (id) => {
      await delay();
      const referral = MOCK_STATS.referralsList.find(r => r.id === Number(id));
      if (!referral) {
        return { success: false, error: 'Referral not found' };
      }
      return { success: true, data: { referral } };
    },

    grant: async (id) => {
      await delay();
      const referral = MOCK_STATS.referralsList.find(r => r.id === Number(id));
      if (!referral) {
        return { success: false, error: 'Referral not found' };
      }
      referral.status = 'granted';
      referral.grantedAt = new Date().toISOString();
      return {
        success: true,
        data: {
          message: 'Referral reward granted successfully',
          referral: { id: referral.id, status: referral.status, grantedAt: referral.grantedAt }
        }
      };
    },

    cancel: async (id, reason) => {
      await delay();
      const referral = MOCK_STATS.referralsList.find(r => r.id === Number(id));
      if (!referral) {
        return { success: false, error: 'Referral not found' };
      }
      referral.status = 'canceled';
      return {
        success: true,
        data: {
          message: 'Referral canceled successfully',
          referral: { id: referral.id, status: referral.status }
        }
      };
    },

    getCodes: async (params = {}) => {
      await delay();
      const page = Number(params.page ?? 1);
      const limit = Number(params.limit ?? 20);
      const startIndex = (page - 1) * limit;
      const sliced = MOCK_STATS.referralCodes.slice(startIndex, startIndex + limit);
      return {
        success: true,
        data: {
          data: sliced,
          pagination: {
            page,
            limit,
            total: MOCK_STATS.referralCodes.length,
            totalPages: Math.ceil(MOCK_STATS.referralCodes.length / limit)
          }
        }
      };
    },

    getUserReferrals: async (userId) => {
      await delay();
      const userCodes = MOCK_STATS.referralCodes.filter(c => c.user.id === Number(userId));
      const userReferrals = MOCK_STATS.referralsList.filter(r => r.referrer.id === Number(userId));
      return {
        success: true,
        data: {
          asReferrer: userCodes.length > 0 ? {
            code: userCodes[0].code,
            codeActive: userCodes[0].active,
            totalReferrals: userCodes[0].totalReferrals,
            successfulReferrals: userCodes[0].successfulReferrals,
            pendingReferrals: userCodes[0].totalReferrals - userCodes[0].successfulReferrals,
            totalHoursEarned: userCodes[0].successfulReferrals * 10,
            referrals: userReferrals.map(r => ({
              id: r.id,
              referee: r.referee,
              status: r.status,
              rewardHours: r.rewardHours,
              createdAt: r.createdAt
            }))
          } : null,
          asReferee: null
        }
      };
    }
  }
};

export default API;
